module.exports = __webpack_public_path__ + "static/media/bullet_green.7c573253.svg";